import React from "react";
import { ArrowRight, Check } from "lucide-react";

const JOURNEY = [
  { step: "Airport Transfer", status: "Arranged on arrival" },
  { step: "Workspace", status: "Coworking — booked in advance" },
  { step: "Dinner Reservation", status: "Restaurant confirmed" },
  { step: "Hotel", status: "Check-in ready" },
  { step: "Guided Experience", status: "Next day — confirmed" },
];

const SERVICES = [
  "Dedicated airport transfers",
  "Restaurant and experience reservations",
  "Itinerary planning across Work, Stay and Play",
  "Special occasion coordination",
  "Tailored recommendations",
];

export default function PlayConcierge() {
  return (
    <section id="concierge" className="relative overflow-hidden bg-[#012d6e] py-20">
      <div className="pointer-events-none absolute right-0 top-0 h-[400px] w-[500px] rounded-full bg-[#017bef]/[0.12] blur-[64px]" />
      <div className="pointer-events-none absolute bottom-0 left-0 h-[300px] w-[400px] rounded-full bg-[#0ea5e9]/[0.08] blur-[64px]" />

      <div className="relative mx-auto grid max-w-[1440px] grid-cols-1 items-center gap-16 px-[16px] sm:px-8 lg:grid-cols-2">
        <div>
          <span className="inline-block rounded-full bg-[#017bef] px-[16px] py-1.5 text-[12px] font-bold uppercase leading-4 tracking-[1.2px] text-white">
            SPACIA PLAY
          </span>
          <h2 className="pt-[16px] text-[36px] font-bold leading-[1.1] tracking-[-1.2px] text-white sm:text-[48px] sm:leading-[48px]">
            Concierge
          </h2>
          <p className="pt-[12px] text-[18px] font-semibold leading-7 text-[#60a5fa]">
            The human touch behind the platform.
          </p>
          <p className="pt-[16px] text-[16px] leading-[26px] text-white">
            SPACIA Concierge provides personalised support to help you plan and manage every part of your Work, Stay and
            Play experience with ease.
          </p>
          <p className="pt-[12px] text-[14px] leading-[22.75px] text-white">
            Whether it's arranging transport, securing a reservation, handling a special request or curating a full
            itinerary, Concierge takes care of the details so you don't have to.
          </p>

          <div className="mt-8 rounded-2xl border-[1px] border-solid border-white/[0.12] bg-white/[0.08] p-[20px]">
            <p className="text-[12px] font-semibold uppercase leading-4 tracking-[1.2px] text-white/40">
              Example journey
            </p>
            <ol className="pt-[16px]">
              {JOURNEY.map((item, index) => (
                <li key={item.step} className="relative flex items-start gap-[12px] pb-[16px] last:pb-0">
                  {index < JOURNEY.length - 1 && (
                    <span className="absolute bottom-0 left-[6.5px] top-[16px] w-px bg-white/20" />
                  )}
                  <span className="relative mt-[3px] size-3.5 shrink-0 rounded-full border-[1px] border-solid border-[#60a5fa] bg-[#60a5fa]/30" />
                  <div className="flex flex-1 flex-col gap-0.5 sm:flex-row sm:items-center sm:justify-between">
                    <span className="text-[14px] font-semibold leading-5 text-white/70">{item.step}</span>
                    <span className="text-[12px] leading-4 text-white">{item.status}</span>
                  </div>
                </li>
              ))}
            </ol>
          </div>

          <ul className="space-y-2.5 pt-8">
            {SERVICES.map(item => (
              <li key={item} className="flex items-center gap-2.5 text-[14px] leading-5 text-white">
                <span className="flex size-4 shrink-0 items-center justify-center rounded-full bg-white">
                  <Check className="size-2.5 text-[#012d6e]" />
                </span>
                {item}
              </li>
            ))}
          </ul>

          <button
            type="button"
            onClick={() => {
              window.location.href = "mailto:sales@spacia.africa";
            }}
            className="mt-8 inline-flex items-center gap-2 rounded-full bg-[#017bef] px-7 py-3.5 text-[14px] font-bold leading-5 text-white drop-shadow-[0_4px_8px_rgba(1,123,239,0.3)] transition-colors hover:bg-[#0062c0]"
          >
            Speak to Concierge
            <ArrowRight className="size-[15px]" />
          </button>
        </div>

        <img
          src="/figma-assets/play/concierge.jpg"
          alt="Concierge"
          className="h-[420px] w-full rounded-3xl object-cover lg:h-[875px]"
        />
      </div>
    </section>
  );
}
